module.exports = __webpack_public_path__ + "static/img/my.d93281b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/my.png
// module id = 4Ysc
// module chunks = 31